const remx = require('remx');

const state = remx.state({
    reload_table: false,
    get_data_per : {},
    data_pelanggan : {},
    data_kategori : [],
    data_kategori_per : {},
    pelanggan_id : '',
    lat_lng : {lat : '', lng : ''},
    kategori_id : '',
    form_view : 'resume',
    type_view : 'day',
    date_view : new Date(),
    year_view : (new Date()).getFullYear(),
    month_view : (new Date()).getMonth(),
    data_export: [],
    data_klasifikasi : {kategori_id : '', klasifikasi_id : '', sub_klasifikasi_id: ''},
    change_password: false,
    modal_kategori: false,
    modal_add_traffic: false,
    modal_kategori_data: {
        kategori_id : '',
        kategori: '',
        klasifikasi_id: '',
        klasifikasi : '',
        sub_klasifikasi_id : '',
        sub_klasifikasi : ''
    },
    tipe_show: 'kategori'
});

const setters = remx.setters({
    setReloadTable(reload_table) {
        state.reload_table = reload_table
    },
    setDataKategori(data_kategori){
        state.data_kategori = data_kategori
    },
    setDataKategoriPer(data_kategori_per){
        state.data_kategori_per = data_kategori_per
    },
    setDataPer(get_data_per){
        state.get_data_per = get_data_per
    },
    setDataPelanggan(data_pelanggan){
        state.data_pelanggan = data_pelanggan
    },
    setDataPelangganId(pelanggan_id){
        state.pelanggan_id = pelanggan_id
    },
    setLatLon(lat_lng){
        state.lat_lng = lat_lng
    },
    setDataKategoriId(kategori_id){
        state.kategori_id = kategori_id
    },
    setDataFormView(form_view){
        state.form_view = form_view
    },
    setDataTypeView(type_view){
        state.type_view = type_view
    },
    setDataYearView(year_view) {
        state.year_view = year_view
    },
    setDataMonthView(month_view){
        state.month_view = month_view
    },
    setDataDateView(date_view){
        state.date_view = date_view
    },
    setDataExport(data_export){
        state.data_export = data_export
    },
    setDataKlasifikasi(data_klasifikasi){
        state.data_klasifikasi = data_klasifikasi
    },
    setChangePassword(change_password){
        state.change_password = change_password
    },
    setModalKategori(modal_kategori){
        state.modal_kategori = modal_kategori
    },
    setModalKategoriData(modal_kategori_data){
        state.modal_kategori_data = modal_kategori_data
    },
    setDataTipeShow(tipe_show){
        state.tipe_show = tipe_show;
    },
    setModalTraffic(modal_add_traffic){
        state.modal_add_traffic = modal_add_traffic;
    }
});

const getters = remx.getters({
    getReloadTable(){
        return state.reload_table;
    },
    getDataKategori(){
        return state.data_kategori;
    },
    getDataKategoriPer(){
        return state.data_kategori_per;
    },
    getDataPer(){
        return state.get_data_per;
    },
    getDataPelanggan(){
        return state.data_pelanggan;
    },
    getDataPelangganId(){
        return state.pelanggan_id;
    },
    getLatLon(){
        return state.lat_lng;
    },
    getDataKategoriId(){
        return state.kategori_id;
    },
    getDataFormView(){
        return state.form_view;
    },
    getDataTypeView(){
        return state.type_view;
    },
    getDataYearView(){
        return state.year_view;
    },
    getDataMonthView(){
        return state.month_view;
    },
    getDataDateView(){
        return state.date_view;
    },
    getDataExport(){
        return state.data_export;
    },
    getDataKlasifikasi(){
        return state.data_klasifikasi;
    },
    getChangePassword(){
        return state.change_password;
    },
    getModalKategori(){
        return state.modal_kategori;
    },
    getModalKategoriData(){
        return state.modal_kategori_data;
    },
    getDataTipeShow(){
        return state.tipe_show;
    },
    getModalTraffic(){
        return state.modal_add_traffic
    }
});


module.exports = {
    setters,
    getters,
}